export default __webpack_public_path__ + "static/media/Xtime-Mobile.c0d82edb.png";